import React, { useEffect, useState } from "react";
import BillingCenter from "./BillingCenter";
import Loader from "../Loader";
import { reportViewableUserIds } from "../../control/Constant";


const Billing = () => {
    const [enquiryShow, setEnquiryMemberShow] = useState(false)
    const [useLoader, setuseLoader] = useState(false)
    const loggedUserId = sessionStorage.getItem('loggedUserId');
    const isReportViewable = reportViewableUserIds.some((id => id?.toLowerCase() === loggedUserId?.toLowerCase()));

    useEffect(() => {
        if(isReportViewable == false) {
            window.location.href = "/";
        }
    }, [])

    return(
        <>
        {useLoader && <div className='fixed inset-0 z-50 bg-white bg-opacity-30 backdrop-blur-sm  pointer-events-auto'><Loader useLoader={useLoader} /></div>}
        <BillingCenter setEnquiryMemberShow={setEnquiryMemberShow} refrencepage="billingCenter" setuseLoader={setuseLoader} />
        </>
    )
}

export default Billing;